/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete } from '../fn/submissions-cycle-v-2/delete-submissions-cycle-api-v-2-submissions-cycle-org-id-delete';
import { DeleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete$Params } from '../fn/submissions-cycle-v-2/delete-submissions-cycle-api-v-2-submissions-cycle-org-id-delete';
import { getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet } from '../fn/submissions-cycle-v-2/get-all-submissions-cycles-api-v-2-submissions-cycle-org-all-get';
import { GetAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet$Params } from '../fn/submissions-cycle-v-2/get-all-submissions-cycles-api-v-2-submissions-cycle-org-all-get';
import { getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet } from '../fn/submissions-cycle-v-2/get-submissions-cycles-information-api-v-2-submissions-cycle-org-submissions-info-get';
import { GetSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet$Params } from '../fn/submissions-cycle-v-2/get-submissions-cycles-information-api-v-2-submissions-cycle-org-submissions-info-get';
import { PageSubmissionsCycle } from '../models/page-submissions-cycle';
import { SubmissionsCycleDeleteResponse } from '../models/submissions-cycle-delete-response';
import { SubmissionsCycleSubmissionsInfo } from '../models/submissions-cycle-submissions-info';

@Injectable({ providedIn: 'root' })
export class SubmissionsCycleV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet()` */
  static readonly GetAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGetPath = '/api/v2/submissions-cycle/{org}/all';

  /**
   * Get All Submissions Cycles.
   *
   * Retrieve a paginated list of submissions cycles, optionally filtered by access mode.
   *
   * This endpoint fetches all submissions-cycle records and returns them in pages.
   * Depending on the `mode` query parameter, it applies one of three behaviors:
   *
   * - **upstream**: return every cycle whose `owner_org_id` is empty or matches the
   *     current `{org}` path parameter
   * - **secretariat**: return only those cycles owned by the current tenant
   * - **(no mode)**: return all cycles, with linked data fetched
   *
   * After fetching, if a cycle has an `owner_org_id`, its corresponding organization’s
   * name is looked up and added as `owner_org_name` in each record.
   *
   * Parameters:
   *     org (Any):
   *         The organization context from the URL path, resolved via `get_org_details`.
   *     tenant (Any):
   *         The current tenant identifier, injected via `get_tenant`.
   *     mode (Literal["upstream", "secretariat"], optional):
   *         If `"upstream"`, filters to cycles owned by or unassigned to `org`.
   *         If `"secretariat"`, filters to cycles owned by `tenant`.
   *         If omitted, no additional filtering is applied.
   *
   * Returns:
   *     Page[schemas.SubmissionsCycle]:
   *         A paginated list of submissions cycles, each with an added
   *         `owner_org_name` where applicable.
   *
   * Raises:
   *     HTTPException:
   *         If the authenticated user is not authorized for the given `org` or
   *         if other dependency-based checks fail.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet$Response(params: GetAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSubmissionsCycle>> {
    return getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Submissions Cycles.
   *
   * Retrieve a paginated list of submissions cycles, optionally filtered by access mode.
   *
   * This endpoint fetches all submissions-cycle records and returns them in pages.
   * Depending on the `mode` query parameter, it applies one of three behaviors:
   *
   * - **upstream**: return every cycle whose `owner_org_id` is empty or matches the
   *     current `{org}` path parameter
   * - **secretariat**: return only those cycles owned by the current tenant
   * - **(no mode)**: return all cycles, with linked data fetched
   *
   * After fetching, if a cycle has an `owner_org_id`, its corresponding organization’s
   * name is looked up and added as `owner_org_name` in each record.
   *
   * Parameters:
   *     org (Any):
   *         The organization context from the URL path, resolved via `get_org_details`.
   *     tenant (Any):
   *         The current tenant identifier, injected via `get_tenant`.
   *     mode (Literal["upstream", "secretariat"], optional):
   *         If `"upstream"`, filters to cycles owned by or unassigned to `org`.
   *         If `"secretariat"`, filters to cycles owned by `tenant`.
   *         If omitted, no additional filtering is applied.
   *
   * Returns:
   *     Page[schemas.SubmissionsCycle]:
   *         A paginated list of submissions cycles, each with an added
   *         `owner_org_name` where applicable.
   *
   * Raises:
   *     HTTPException:
   *         If the authenticated user is not authorized for the given `org` or
   *         if other dependency-based checks fail.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet(params: GetAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet$Params, context?: HttpContext): Observable<PageSubmissionsCycle> {
    return this.getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSubmissionsCycle>): PageSubmissionsCycle => r.body)
    );
  }

  /** Path part for operation `getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet()` */
  static readonly GetSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGetPath = '/api/v2/submissions-cycle/{org}/submissions/info';

  /**
   * Get Submissions Cycles Information.
   *
   * Retrieve detailed submissions cycle information for an organization.
   *
   * This endpoint gathers and returns detailed information about the submissions
   * cycles associated with a given organization's submissions. It performs the
   * following operations:
   *
   * 1. Fetches all submissions owned by the organization.
   * 2. Filters out submissions where the recipient organization matches the tenant.
   * 3. Identifies unique submissions cycle IDs from the remaining submissions.
   * 4. For each submissions cycle, retrieves detailed cycle information including:
   *    - The cycle title and unique identifier.
   *    - Form configuration details associated with the cycle.
   *    - A list of recipient organizations along with:
   *      - The recipient organization's identifier.
   *      - The recipient organization's company name.
   *      - Submissions data specific to the recipient and submissions cycle.
   *
   * Parameters:
   *     tenant (Any): The tenant information, resolved via the `deps.get_tenant` dependency.
   *     org (Any): The organization details, resolved via the `deps.get_org_details` dependency.
   *
   * Returns:
   *     list[schemas.SubmissionsCycleSubmissionsInfo]: A list of dictionaries where each
   *     dictionary contains the following keys:
   *       - "submissions_cycle_name": The title of the submissions cycle.
   *       - "submissions_cycle_id": The unique identifier of the submissions cycle.
   *       - "submissions_cycle_form_config": The form configuration data associated
   *         with the cycle (retrieved using the form version).
   *       - "submissions_recipients": A list of dictionaries, each containing:
   *           - "recipient_org_id": The identifier of the recipient organization.
   *           - "recipient_company_name": The company name of the recipient organization.
   *           - "recipient_submissions": The submissions data for the recipient in the cycle.
   *
   * Raises:
   *     HTTPException: If an error occurs while retrieving or processing the submissions
   *     data, an HTTPException may be raised to indicate the issue.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet$Response(params: GetSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsCycleSubmissionsInfo>>> {
    return getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Submissions Cycles Information.
   *
   * Retrieve detailed submissions cycle information for an organization.
   *
   * This endpoint gathers and returns detailed information about the submissions
   * cycles associated with a given organization's submissions. It performs the
   * following operations:
   *
   * 1. Fetches all submissions owned by the organization.
   * 2. Filters out submissions where the recipient organization matches the tenant.
   * 3. Identifies unique submissions cycle IDs from the remaining submissions.
   * 4. For each submissions cycle, retrieves detailed cycle information including:
   *    - The cycle title and unique identifier.
   *    - Form configuration details associated with the cycle.
   *    - A list of recipient organizations along with:
   *      - The recipient organization's identifier.
   *      - The recipient organization's company name.
   *      - Submissions data specific to the recipient and submissions cycle.
   *
   * Parameters:
   *     tenant (Any): The tenant information, resolved via the `deps.get_tenant` dependency.
   *     org (Any): The organization details, resolved via the `deps.get_org_details` dependency.
   *
   * Returns:
   *     list[schemas.SubmissionsCycleSubmissionsInfo]: A list of dictionaries where each
   *     dictionary contains the following keys:
   *       - "submissions_cycle_name": The title of the submissions cycle.
   *       - "submissions_cycle_id": The unique identifier of the submissions cycle.
   *       - "submissions_cycle_form_config": The form configuration data associated
   *         with the cycle (retrieved using the form version).
   *       - "submissions_recipients": A list of dictionaries, each containing:
   *           - "recipient_org_id": The identifier of the recipient organization.
   *           - "recipient_company_name": The company name of the recipient organization.
   *           - "recipient_submissions": The submissions data for the recipient in the cycle.
   *
   * Raises:
   *     HTTPException: If an error occurs while retrieving or processing the submissions
   *     data, an HTTPException may be raised to indicate the issue.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet(params: GetSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet$Params, context?: HttpContext): Observable<Array<SubmissionsCycleSubmissionsInfo>> {
    return this.getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsCycleSubmissionsInfo>>): Array<SubmissionsCycleSubmissionsInfo> => r.body)
    );
  }

  /** Path part for operation `deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete()` */
  static readonly DeleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDeletePath = '/api/v2/submissions-cycle/{org}/{id}';

  /**
   * Delete Submissions Cycle.
   *
   * Delete a submissions cycle record by its ID.
   *
   * This endpoint deletes an existing submissions cycle record identified by the provided ID.
   * It ensures that the requesting organization is an agridence member before performing the deletion.
   * The endpoint performs a soft delete by marking the record as deleted rather than permanently removing it.
   *
   * Args:
   *     org (Any): Organization details resolved via dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submissions cycle to delete.
   *
   * Returns:
   *     schemas.SubmissionsCycleDeleteResponse: A structured response with deletion details including
   *     the number of submissions that were also soft deleted.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *     HTTPException: If the submissions cycle with the given ID is not found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete$Response(params: DeleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsCycleDeleteResponse>> {
    return deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Submissions Cycle.
   *
   * Delete a submissions cycle record by its ID.
   *
   * This endpoint deletes an existing submissions cycle record identified by the provided ID.
   * It ensures that the requesting organization is an agridence member before performing the deletion.
   * The endpoint performs a soft delete by marking the record as deleted rather than permanently removing it.
   *
   * Args:
   *     org (Any): Organization details resolved via dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submissions cycle to delete.
   *
   * Returns:
   *     schemas.SubmissionsCycleDeleteResponse: A structured response with deletion details including
   *     the number of submissions that were also soft deleted.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *     HTTPException: If the submissions cycle with the given ID is not found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete(params: DeleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete$Params, context?: HttpContext): Observable<SubmissionsCycleDeleteResponse> {
    return this.deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionsCycleDeleteResponse>): SubmissionsCycleDeleteResponse => r.body)
    );
  }

}
